import { render, staticRenderFns } from "./d-passage.vue?vue&type=template&id=5d09aae1&scoped=true&"
import script from "./d-passage.vue?vue&type=script&lang=js&"
export * from "./d-passage.vue?vue&type=script&lang=js&"
import style0 from "./d-passage.vue?vue&type=style&index=0&id=5d09aae1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d09aae1",
  null
  
)

export default component.exports